import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { eLinkButtonTarget } from './link-button.model';
import { IconComponent } from '../icon/icon.component';
import { ElementsService } from '../../../services/elements.service';
@Component({
  selector: 'nuc-link-button',
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './link-button.component.html',
  styleUrl: './link-button.component.scss',
})
export class LinkButtonComponent implements OnInit {
  @Input() href: string = '';
  @Input() target: string;
  // eLinkButtonTarget = eLinkButtonTarget.NEW_WINDOW;
  @Input() styleClass: string;
  @Input() linkIcon: string;
  @Input() id: string;
  @Input() iconStyleClass: string;
  @Input() iconColor: string;
  @Input() sizeClassValue: string;
  @Input() disabled: boolean;
  eLinkTargetType: eLinkButtonTarget; //changimg target string to enum
  eLinkButtonTarget = eLinkButtonTarget;
  //_blank: new tab
  //_self: same window and tab

  @Input({ required: true }) text: string = 'Link';

  isRouterLink: boolean = false;

  @Output()
  onClick: EventEmitter<string> = new EventEmitter();

  constructor(private router: Router, private elementsService: ElementsService) {}

  ngOnInit(): void {
    const sameAppUrl = window.location.origin;
    this.eLinkTargetType = this.mapLinkType(this.target);
    if (this.href?.startsWith('/') || this.href?.startsWith(sameAppUrl)) {
      if (this.target == '_self') {
        this.isRouterLink = true;
        this.href = this.href.replace(sameAppUrl, ''); // Convert full URL to relative path for Angular routing
      }
    }
  }

  click(event?:Event): void {
    if (this.isRouterLink) {
      if (!this.elementsService.isEmbeddedInAngularApp) {
        window.location.href = this.href;
      } else {
        this.router.navigate([this.href]);
      }
    } else {
      if (this.href) {        
        if(this.href == '/#'){
          event.preventDefault();
          return;
        }
        window.open(this.href, this.target);
      } else {        
        this.onClick.emit(this.id || '');
      }
    }
  }

  private mapLinkType(target: string): eLinkButtonTarget {
    switch (target) {
      case '_blank':
        return eLinkButtonTarget.NEW_WINDOW;
      case '_top':
        return eLinkButtonTarget.TOP;
      case '_self':
        return eLinkButtonTarget.SELF;
      case 'default':
        return eLinkButtonTarget.SELF;
      case 'newTab':
        return eLinkButtonTarget.NEW_WINDOW;
      case 'newWindow':
        return eLinkButtonTarget.NEW_WINDOW;
      default:
        return eLinkButtonTarget.NEW_WINDOW;
    }
  }
}
